import {useEffect} from "react";


export const useAddSupportButton = () => {
    useEffect(() => {
        const script = document.createElement('script');

        script.text = `
                (function (w, d, u) {
            var s = d.createElement('script');
            s.async = true;
            s.src = u + '?' + (Date.now() / 60000 | 0);
            var h = d.getElementsByTagName('script')[0];
            h.parentNode.insertBefore(s, h);
        })(window, document, 'https://cdn.bitrix24.com/b17366541/crm/site_button/loader_7_jsqxt0.js');
        `;
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }
    }, []);
}